// extracted by mini-css-extract-plugin
module.exports = {"unit":"var(--ring-unit)","confirmationLabel":"RemoveCertificateButton__confirmationLabel--xF"};